import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Workstations from './workstations';

import messages from './../messages';
import styles from './styles.module.less';
import { usePrinters } from '../../../../hooks/printers/use-printers';

const CONNECT_SETUP_URL = '/settings/connect';

const SelectPrinter = ({ setPrintSettingForDocType }) => {
  const { printers } = usePrinters();
  const hasActiveWorkstation = printers.some((ws) => ws.workstationIsOnline);

  return hasActiveWorkstation ? (
    <Workstations printersByWorkstation={printers} setPrintSettingForDocType={setPrintSettingForDocType} />
  ) : (
    <div className={styles['install-connect-message']}>
      <FormattedMessage {...messages.connectNotFound} />
      {/* wrap this message in a div because the chunk below will make two separate elements
        and we want this to appear as one message */}
      <div>
        <FormattedMessage
          {...messages.pleaseSetupConnect}
          values={{
            link: (chunks) => <Link to={CONNECT_SETUP_URL}>{chunks}</Link>,
          }}
        />
      </div>
    </div>
  );
};

SelectPrinter.propTypes = {
  setPrintSettingForDocType: PropTypes.func.isRequired,
};

export default SelectPrinter;
